import { Link } from 'react-router-dom';
import { useTranslate } from '@above-the-treeline/localization';

const CommunityGuidelinesLink = () => {
	const { translate } = useTranslate();
	const url =
		'https://www.abovethetreeline.com/edelweiss-community-guidelines/';
	return (
		<div className="community-guidelines-link-container">
			<Link to={{ pathname: url }} target="_blank">
				{translate('community_guidelines')}
			</Link>
		</div>
	);
};

export default CommunityGuidelinesLink;
